import { POST, GET } from '@/utils/request'
import Api from './url'

export const getExplainInfo = async (params: object) => {
  return await GET({
    url: Api.getExplainInfo,
    params,
    showError: false
  })
}
